import { Component, OnInit } from '@angular/core';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { SMS_Interface } from 'src/app/Interface/SMS_Interface';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SMSService } from 'src/app/Service/SMS/SMS.service';

@Component({
  selector: 'app-SMSHistory',
  templateUrl: './SMSHistory.component.html',
  styleUrls: ['./SMSHistory.component.scss']
})
export class SMSHistoryComponent implements OnInit {

  Token:String=""
  Filter_Key:string=""
  Filter_Title:string="0"
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private SMS_Service:SMSService,
    private Nav_Service:NavService,
  ) { }


  DataList_SMS:Array<SMS_Interface>=[]
  DataList_Title:Array<General_Interface>=[]

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1166).subscribe(
      data=>{
        this.ReadData_SMS_Title()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_SMS_Title(){
    this.Procssing=true
    this.SMS_Service.GetTitle(this.Token).subscribe(
      data=>{
        this.DataList_Title=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_SMS(){
    this.Procssing=true
      this.SMS_Service.GetRecord(Number(this.Filter_Title),
      this.Filter_Key,
      this.Token).subscribe(
      data=>{
        this.DataList_SMS=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
